import { React, useState, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Form, Container, Row, Col } from 'react-bootstrap';
import * as api from 'services/api';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useUserContext } from 'contexts/UserContext';
import { useTranslation } from 'react-i18next';

const EditOverridecodeModal = forwardRef(
    
    function EditOverridecodeModal({ state, show, setShow, onClose }, ref) {
        const { t } = useTranslation();
        const navigate = useNavigate();
        const { userData } = useUserContext();
        const { controlCentre, updateControlCentre } = useControlCentreContext();
        //#region ------------------------------- STATES
        const [newOverride] = useState(null);
        const [error, setError] = useState(null);
        const [success, setSuccess] = useState(null);
        const [disabledButt, setDisabledButt] = useState(false);
        //#endregion


        //#region ------------------------------- EFFECTS

        //#endregion

        //#region ------------------------------- HANDLERS 

        const handleSubmit = async (order) => {
            setError(null);
            setSuccess(null);
            try {
                let response = null;
                switch (order) {
                    case 'UPDATE':
                        response = await api.updateControlCentrePseudocodeConfig(controlCentre.centreid, state.controlCentreConfigId, { overrideid: newOverride });
                        console.log('update RESPONSE : ', response);
                        if (response.status === 200 && response.data === true) {
                            setSuccess(t('ccPseudoCodeModified'));
                            setDisabledButt(true);
                        }
                        if (response.data === false) {
                            setError(t('ccErrorSaveChanges'));
                        }
                        break;
                    case 'DELETE':
                        response = await api.deleteControlCentrePseudocodeConfig(controlCentre.centreid, state.controlCentreConfigId);
                        if (response.status === 200 && response.data === true) {
                            setSuccess(t('ccPseudoCodeDisassociated'));
                            setDisabledButt(true);
                        }
                        if (response.data === false) {
                            setError(t('ccErrorSaveChanges'));
                        }
                        break;
                    default:
                        break;
                }



            } catch (error) {
                console.log('SERVER ERROR...', error);
                setError(t('ccErrorSaveChanges'));
            }
        }
        const handleManagePseudocodes = (centreid) => {
            if (userData && userData.role === 'Admin') {
                updateControlCentre({ ...controlCentre, origin: state })
                navigate(`/pseudocodesManagement/${centreid}`);
            }
        }
        const handleCloseModal = () => {
            setShow(false);
            setError(null);
            setSuccess(null);
            setDisabledButt(false);
            onClose();
        }
        //#endregion

        return (
            <Modal
                show={show} onHide={handleCloseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('ccEdit')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Container>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="controlcentreid">
                                        <Form.Label>{t('ccControlCentre')} </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={state.controlCentreText}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>

                                    <Form.Group className="mb-3" controlId="pseudoid">
                                        <Form.Label>{t('ccPseudoCodeID')} </Form.Label>
                                        <Form.Control type="text" value={state.pseudoCodeId} disabled />
                                    </Form.Group>

                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudo">
                                        <Form.Label>{t('ccPseudoCode')} </Form.Label>
                                        <Form.Control type="text" value={state.pseudoCode} disabled />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudotext">
                                        <Form.Label>{t('ccPseudoCodeText')}</Form.Label>
                                        <Form.Control type="text" value={state.pseudoCodeText} disabled />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudodescrip">
                                        <Form.Label>{t('ccPseudoCodeDescription')} </Form.Label>
                                        <Form.Control type="text" value={state.pseudoCodeDescription} disabled />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="pseudodescrip">
                                        <Form.Label>{t('ccOverrideID')}</Form.Label>
                                        <div className='d-flex flex-row'>
                                            <Form.Control type="text" value={state.overrideCodeId} disabled />
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col>

                                </Col>
                            </Row>
                            {error && <p className="text-danger fw-semibold">{error}</p>}
                            {success && <p className='text-success fw-semibold'>{success}</p>}

                        </Container>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='d-flex flex-row justify-content-between'>
                    <Button variant='light' onClick={handleCloseModal}>{t('ccClose')}</Button>
                    <Button variant='danger' className='me-3' disabled={disabledButt} onClick={() => handleSubmit('DELETE')}>{t('ccDeleteConfiguration')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }

)

export default EditOverridecodeModal;